import { useDispatch, useSelector } from 'react-redux'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectContactConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

type Params = {
  verifyEmail: (email: string) => void
  captionForceEmail: (value: boolean) => void
  updateNeverBounce: (value: string) => void
  removeErrors: (key: string) => void
  neverBounceResult: string | boolean | null
}

const useEmail = ({ verifyEmail, captionForceEmail, updateNeverBounce, removeErrors, neverBounceResult }: Params) => {
  const dispatch = useDispatch()
  const { emailSuggestion } = useSelector(selectContactConfig)

  const clearEmailSuggestion = () =>
    // @ts-ignore
    dispatch(updateClientData({ data: { emailSuggestion: null }, name: 'config' }))

  const hasError = neverBounceResult === false
  const isValid = neverBounceResult === 'valid' || neverBounceResult === 'force'
  const status = hasError ? 'error' : isValid ? 'valid' : ''

  const onBlur = (email: string | null) => verifyEmail(email as string)

  const onAcceptSuggestion = (correctedEmail: string) => {
    clearEmailSuggestion()
    verifyEmail(correctedEmail)
  }

  const forceAddress = () => {
    captionForceEmail(true)
    updateNeverBounce('force')
    removeErrors('email')
  }

  return { emailSuggestion, status, onBlur, onAcceptSuggestion, clearEmailSuggestion, forceAddress }
}

export default useEmail
